"use client";

import { MotionValue, UseScrollOptions, useSpring } from "motion/react";
import * as motion from "motion/react-client";
import { ReactNode } from "react";
import { rh } from "../../hooks";
import { Scroll } from "./Scroll";

export function ScrollYIndicator({
  children,
  options,
  color = "var(--yz-foreground)",
  height = 10
}: {
  children: ReactNode;
  options?: UseScrollOptions;
  color?: string | MotionValue<string>;
  height?: number;
}) {
  return (
    <Scroll options={{ ...(options ?? {}), axis: "y" }}>
      <Indicator
        color={color}
        height={height}
      />
      {children}
    </Scroll>
  );
}

function Indicator({
  color = "var(--yz-foreground)",
  height = 10
}: {
  color?: string | MotionValue<string>;
  height?: number;
}) {
  const { scrollYProgress, type } = rh.useScrollProgress();

  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });

  return (
    <motion.div
      style={{
        scaleX,
        originX: 0,
        position: type === "container" ? "absolute" : "fixed",
        top: 0,
        left: 0,
        right: 0,
        height,
        backgroundColor: color,
        zIndex: 99999
      }}
    />
  );
}
